import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "./router";
import { storeInit } from "@/store/index.js";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {

  const authStore = storeInit();

  // 目标页面需要登录，且当前未登录
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    authStore.setTargetPath(to.fullPath); 
    authStore.openLoginModal(); // 自动打开登录弹窗
    next(false); // 阻止路由跳转
  } else {
    next(); // 允许跳转
  }
});

export default router
